__turbopack_context__.v({
  "expand_btn": "ImtNlW_expand_btn",
  "list_block": "ImtNlW_list_block",
  "richtext": "ImtNlW_richtext",
});
